import React, { createContext, useEffect, useState } from "react";
import { useResetRecoilState, useSetRecoilState } from "recoil";
import { homeBannerState, homeLogoState, isLoadingState, themeColorState } from "../../../recoil/states/default";
import axiosRc from '../../../config/axios-rc'
import { getSearchHistoryStorage, setHomeImageStorage, setThemeStorage } from "../../../utils/localStorage";
import { useNavigate, useParams } from "react-router-dom";

const initialState = {
    ddlBu: [],
    ddlOrgUnit: [],
    // ddlEmploymentType: [],
    ddlPositionGroup: [],
    ddlPositionCareer: [],
    ddlProvince: [],
    getDDLLabel: () => { },
    setOrgUnitIdContext: () => { },
    orgUnitIdContext: null,
    homeData: null,
    cards: null,
    setQuery: () => { },
    query: {
        fetchHome: null,
        searchKeyword: null,
        buCode: null,
        orgUnitCode: null,
        positionGroupName: null,
        positionCareerCode: null,
        province: null,
        isAnnual: true,
        isNotAnnual: true,
        isGeneral: true,
        isNotGeneral: true,
    }
}

const HomeContext = createContext(initialState);

const HomeContextProvider = ({ children }) => {
    const setIsLoading = useSetRecoilState(isLoadingState)
    const setHomeLogo = useSetRecoilState(homeLogoState)
    const resetHomeLogo = useResetRecoilState(homeLogoState)
    const setHomeBanner = useSetRecoilState(homeBannerState)
    const setThemeColor = useSetRecoilState(themeColorState)
    const [allDDL, setAllDDL] = useState(null)
    const [orgUnitIdContext, setOrgUnitIdContext] = useState(null)
    const [datas, setDatas] = useState(null)
    const [cards, setCards] = useState(null)
    const [query, setQuery] = useState({
        fetchHome: false,
        searchKeyword: null,
        buCode: null,
        orgUnitName: null,
        positionGroupName: null,
        employmentTypeName: null,
        positionCareerName: null,
        province: null,
        isAnnual: true,
        isNotAnnual: true,
        isGeneral: true,
        isNotGeneral: true
    })
    const history = useNavigate()
    const { org } = useParams()

    useEffect(() => {
        setIsLoading(true)
        getDefaultData()
        setTimeout(() => { setIsLoading(false) }, 1000)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setIsLoading(true)
        console.log('before get orgUnitIdContext', orgUnitIdContext)
        getDataByOrgUnitId()
        setTimeout(() => { setIsLoading(false) }, 1000)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query, orgUnitIdContext, query.fetchHome])

    const getDefaultData = async () => {
        try {
            const { data } = await axiosRc.get("/jobList/get_default_data");
            const ddl = {
                ddlBu: [],
                ddlOrgUnit: [],
                // ddlEmploymentType: [],
                ddlPositionGroup: [],
                ddlPositionCareer: [],
                ddlProvince: [],
            }

            if (data) {
                if (data.cards) {
                    setCards(data.cards)
                    if (!org) {
                        const storedOrgUnit = getSearchHistoryStorage() 
                        if (storedOrgUnit?.orgUnitName) {
                            history(`/${storedOrgUnit?.orgUnitName}`);
                        } else {
                            setOrgUnitIdContext(data.cards[0].orgUnitId)
                            history(`/${data.cards[0].orgUnitName}`)
                        }
                    }
                }

                ddl.ddlBu = setDDLValue(data.bu, 'orgUnitCode', 'orgUnitName')
                ddl.ddlOrgUnit = setDDLMultiValue(data.orgUnit, 'orgUnitName', 'orgUnitName', 'orgUnitCode')
                // ddl.ddlEmploymentType = setDDLMultiValue(data.employmentType, 'employmentTypeName', 'employmentTypeName')
                ddl.ddlPositionGroup = setDDLMultiValue(data.positionGroup, 'positionGroupName', 'positionGroupName')
                ddl.ddlPositionCareer = setDDLMultiValue(data.positionCareer, 'positionCareerName', 'positionCareerName')
                ddl.ddlProvince = setDDLMultiValue(data.province, 'province', 'province')
            }

            const _all = {
                value: "all",
                label: "ทั้งหมด",
            }
            setAllDDL({
                ddlBu: [_all, ...ddl.ddlBu.filter(item => item.value !== '00')],
                ddlOrgUnit: ddl.ddlOrgUnit,
                // ddlEmploymentType: ddl.ddlEmploymentType,
                ddlPositionGroup: ddl.ddlPositionGroup,
                ddlPositionCareer: ddl.ddlPositionCareer,
                ddlProvince: ddl.ddlProvince,
            })
        }
        catch (err) {
            console.log('error getDefaultData', err)
            setIsLoading(false)
        }
    }

    const getDataByOrgUnitId = async () => {
        try {
            if (orgUnitIdContext) {
                let _empType = null
                if (query.isAnnual === true && query.isNotAnnual === false) {
                    _empType = 'บุคลากรประจำ'
                } else if (query.isAnnual === false && query.isNotAnnual === true) {
                    _empType = 'บุคลากรสัญญาจ้าง'
                } else if (query.isAnnual === false && query.isNotAnnual === false) {
                    _empType = 'ประเภทการว่าจ้าง'
                }

                let _isGeneral = null
                if (!((query.isGeneral && query.isNotGeneral) || (!query.isGeneral && !query.isNotGeneral))) {
                    if (query.isGeneral) {
                        _isGeneral = true;
                    } else if (query.isNotGeneral) {
                        _isGeneral = false;
                    }
                }
                const _query =
                    `?orgUnitId=${orgUnitIdContext}` +
                    (query.searchKeyword ? `&searchKeyword=${query.searchKeyword}` : '') +
                    (query.buCode ? `&buCode=${query.buCode}` : '') +
                    (query.orgUnitName ? `&orgUnitName=${query.orgUnitName}` : '') +
                    (query.positionGroupName ? `&positionGroupName=${query.positionGroupName}` : '') +
                    (_empType ? `&employmentTypeName=${_empType}` : '') +
                    (query.positionCareerName ? `&positionCareerName=${query.positionCareerName}` : '') +
                    (query.province ? `&province=${query.province}` : '') +
                    (_isGeneral !== null ? `&isGeneral=${_isGeneral}` : '');

                const { data } = await axiosRc.get(`/jobList/get_by_org_unit_id/${_query}`);
                if (data) {
                    setDatas(data)
                    setHomeLogo(data.logo)
                    setHomeBanner(data.banner)
                    console.log('get by orgUnit Id : data.banner =>', data)
                    setThemeStorage(orgUnitIdContext === '00' ? data.orgTheme ?? 'red' : data.jobReqContact?.theme)
                    setThemeColor(orgUnitIdContext === '00' ? data.orgTheme ?? 'red' : data.jobReqContact?.theme)
                    setHomeImageStorage({
                        logo: orgUnitIdContext === '00' ? data.logo : data.jobReqContact?.logo,
                        banner: data.banner,
                        theme: orgUnitIdContext === '00' ? data.orgTheme ?? 'red' : data.jobReqContact?.theme,
                    })
                } else {
                    resetHomeLogo()
                }
            }
        }
        catch (err) {
            console.log('error getDataByOrgUnitId', err)
            setIsLoading(false)
        }
    }

    const setDDLValue = (data, fieldValue, fieldLabel) => {
        if (data && data.length > 0) {
            return data.map(item => {
                return {
                    value: item[fieldValue],
                    label: item[fieldLabel]
                }
            })
        }
        return null
    }

    const setDDLMultiValue = (data, fieldValue, fieldLabel, fieldFilter) => {
        let _ddl = [{
            title: 'ทั้งหมด',
            value: 'all',
            key: 'all',
            children: []
        }]
        data.map(async (item) => {
            _ddl[0].children.push({
                id: item[fieldValue],
                title: item[fieldLabel],
                value: item[fieldValue],
                fieldFilter: item[fieldFilter],
                key: item[fieldValue]
            })
        })
        _ddl[0].children.sort(function (a, b) { return a.value - b.value })
        return _ddl
    }

    return (
        <HomeContext.Provider
            value={{
                cards,
                ddlBu: allDDL?.ddlBu,
                ddlOrgUnit: allDDL?.ddlOrgUnit,
                // ddlEmploymentType: allDDL?.ddlEmploymentType,
                ddlPositionGroup: allDDL?.ddlPositionGroup,
                ddlPositionCareer: allDDL?.ddlPositionCareer,
                ddlProvince: allDDL?.ddlProvince,
                setOrgUnitIdContext,
                orgUnitIdContext,
                homeData: datas,
                query: query,
                setQuery,
            }}
        >{children}
        </HomeContext.Provider>
    )
}

export { HomeContextProvider, HomeContext };